export default __webpack_public_path__ + "static/media/search.6658c85b.svg";